// extracted by mini-css-extract-plugin
export var crossed = "style-module--crossed--a0170";
export var form = "style-module--form--36a68";
export var info = "style-module--info--5cecb";
export var policy = "style-module--policy--058e2";
export var price = "style-module--price--12ea3";
export var priceWrap = "style-module--price-wrap--759f1";
export var reg = "style-module--reg--a6d2a";
export var res = "style-module--res--64467";
export var text = "style-module--text--55d98";